import React, { FC } from 'react'
import { cn } from 'shared/utils'
import { Button, Modal } from '@wmgtech/legato'

import { ConditionRender } from 'components/index'

import { IDialogProps } from './Dialog.props'

const Dialog: FC<IDialogProps> = ({
  size = 'md',
  visible,
  title,
  body,
  onOk,
  onCancel,
  classList,
  dataTest,
  hideCancel = true
}) => (
  <Modal
    size={size}
    className={cn(classList)}
    isOpen={visible}
    onClose={!hideCancel ? onCancel.action : onOk.action}
    footer={
      <>
        <ConditionRender
          condition={!hideCancel}
          component={
            <Button
              onClick={onCancel?.action}
              colorType="secondary-black"
              containerStyle="outline"
              label={onCancel?.name}
              data-test={`${dataTest}_btn-cancel`}
            />
          }
        />
        <Button
          onClick={onOk.action}
          colorType="secondary-white"
          containerStyle="outline"
          label={onOk.name}
          data-test={`${dataTest}_btn-ok`}
        />
      </>
    }
    shouldCloseOnOverlayClick
    title={title || ''}
  >
    <div>{body}</div>
  </Modal>
)

export default Dialog
